import OutlineButton from "components/Button/OutlineButton";
import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { MdPictureAsPdf } from "react-icons/md";

interface ButtonExportarPDFProps {
  onClick: () => any;
}

function ButtonExportarPDF({ onClick }: ButtonExportarPDFProps) {
  return (
    <OutlineButton
      p={0}
      w="100%"
      justifyContent="start"
      mb={1}
      border="none"
      onClick={onClick}
    >
      <Flex w={"16px"} mr={-1}>
        <MdPictureAsPdf color={colors.primary} size={34} />
      </Flex>
      Exportar PDF
    </OutlineButton>
  );
}

export default ButtonExportarPDF;
